<div class="background sb-router-outlet__no-header pb-5">
  <div class="container text-center pt-3">
    <img src="https://springbot-assets.s3.us-east-1.amazonaws.com/images/logo-springbot-send.svg" class="sb-logo pt-5">

    <div class="my-5">
      <div *ngIf="verifying">
        <fa-icon [icon]="['fas', 'cog']" [spin]="true" size="2x" class="primary-blue-color"></fa-icon>
      </div>

      <div *ngIf="errorMsg">
        <h1>
          {{ errorMsg }}
        </h1>
      </div>

      <div *ngIf="!verifying && !errorMsg">
        <h1>
          Your email is verified!
        </h1>

        <p>
          You can close this window.
        </p>
      </div>
    </div>
  </div>
</div>
